export enum FormMode {
  Add = 'Add',
  Edit = 'Edit',
  Copy = 'Copy',
  CalibrationOn = "CalibrationOn",
  CalibrationOff = "CalibrationOff",
  Details = "Details"
}